import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://finanza-pronta.impultienda.ar/checkout';
const TRACKING_KEY = 'fin_landing_query';
// Mantiene fbclid / utm_* dell'URL della landing e li passa al checkout.
function withTracking(href: string): string {
  if (typeof window === 'undefined' || href.startsWith('#')) return href;
  let query = window.location.search;
  try {
    if (query && query.length > 1) {
      window.sessionStorage.setItem(TRACKING_KEY, query);
    } else {
      query = window.sessionStorage.getItem(TRACKING_KEY) || '';
    }
  } catch {
    // sessionStorage può essere bloccato: si usa solo la query attuale.
  }
  if (!query || query.length < 2) return href;
  const params = query.replace(/^\?/, '');
  return href + (href.includes('?') ? '&' : '?') + params;
}
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Voglio FINANZA PRONTA™',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  const finalHref = isInternal ? href : withTracking(href);
  const handleClick = () => {
    if (!isInternal) trackInitiateCheckout();
  };
  return <a href={finalHref} onClick={handleClick} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-[#1F9D6B] px-5 py-4 text-center text-sm font-semibold text-white shadow-lg shadow-[#1F9D6B]/30 transition-[transform,background-color] duration-150 ease-out hover:bg-[#178257] active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#1F9D6B]/30 sm:px-9 sm:py-5 sm:text-base ${className}`} data-id="element-65" data-mp="3jwnraavmkxjr">
      <span data-id="element-66" data-mp="biyn92d9dtel">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-67" data-mp="bfau44bq790e" />
    </a>;
}